import React, { useState } from 'react';
import LoadingScreen from './LoadingScreen';
import Desktop from './Desktop';
import './App.css';

function App() {
  const [loading, setLoading] = useState(
    process.env.REACT_APP_SHOW_LOADING !== 'false'
  );

  return (
    <div className="App">
      {loading ? (
        <LoadingScreen onFinish={() => setLoading(false)} />
      ) : (
        <Desktop />
      )}
    </div>
  );
}

export default App;